import { ROUTES } from './routes';

export const PAGE_TAB_VALUES = {
  summary: '1',
  performanceTrends: '2',
  dividends: '3',
  comparison: '4',
  instructions: '5',
  investmentIndicators: '6',
} as const;

export type PageTabKey = keyof typeof PAGE_TAB_VALUES;
export type PageTabValue = (typeof PAGE_TAB_VALUES)[PageTabKey];

export const DEFAULT_PAGE_TAB_VALUE: PageTabValue = PAGE_TAB_VALUES.summary;

const PAGE_TAB_ALIAS_MAP: Record<string, PageTabValue> = {
  '1': PAGE_TAB_VALUES.summary,
  summary: PAGE_TAB_VALUES.summary,
  '2': PAGE_TAB_VALUES.performanceTrends,
  trends: PAGE_TAB_VALUES.performanceTrends,
  'performance-trends': PAGE_TAB_VALUES.performanceTrends,
  performanceTrends: PAGE_TAB_VALUES.performanceTrends,
  '3': PAGE_TAB_VALUES.dividends,
  dividend: PAGE_TAB_VALUES.dividends,
  dividends: PAGE_TAB_VALUES.dividends,
  '4': PAGE_TAB_VALUES.comparison,
  comparison: PAGE_TAB_VALUES.comparison,
  '5': PAGE_TAB_VALUES.instructions,
  instructions: PAGE_TAB_VALUES.instructions,
  filings: PAGE_TAB_VALUES.instructions,
  '6': PAGE_TAB_VALUES.investmentIndicators,
  indicators: PAGE_TAB_VALUES.investmentIndicators,
  'investment-indicators': PAGE_TAB_VALUES.investmentIndicators,
  investmentIndicators: PAGE_TAB_VALUES.investmentIndicators,
};

export const normalizePageTabValue = (
  tab: string | undefined,
): PageTabValue | undefined => {
  const trimmed = tab?.trim();
  if (!trimmed) return undefined;

  return PAGE_TAB_ALIAS_MAP[trimmed] ?? PAGE_TAB_ALIAS_MAP[trimmed.toLowerCase()];
};

export const getPageTabValueForPathname = (
  pathname: string,
): PageTabValue | undefined => {
  switch (pathname) {
    case ROUTES.summary:
      return PAGE_TAB_VALUES.summary;
    case ROUTES.performanceTrends:
      return PAGE_TAB_VALUES.performanceTrends;
    case ROUTES.dividends:
      return PAGE_TAB_VALUES.dividends;
    case ROUTES.comparison:
      return PAGE_TAB_VALUES.comparison;
    case ROUTES.instructions:
      return PAGE_TAB_VALUES.instructions;
    case ROUTES.investmentIndicators:
      return PAGE_TAB_VALUES.investmentIndicators;
    default:
      return undefined;
  }
};

export const getPagePathnameForTabValue = (
  _tab: PageTabValue,
): string => ROUTES.analysis;
